import { IconProps } from './Icon';

export const HomeFilledIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Capa_1"
    viewBox="0 0 14 14"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.7889 6.89022L7.35293 0.458972C7.30659 0.41254 7.25155 0.375704 7.19095 0.35057C7.13036 0.325437 7.0654 0.3125 6.99981 0.3125C6.93421 0.3125 6.86925 0.325437 6.80866 0.35057C6.74806 0.375704 6.69302 0.41254 6.64668 0.458972L0.210742 6.89022C0.0232422 7.07772 -0.0830078 7.33241 -0.0830078 7.59803C-0.0830078 8.1496 0.36543 8.59803 0.916992 8.59803H1.59512V13.1871C1.59512 13.4637 1.81855 13.6871 2.09512 13.6871H5.99981V10.1871H7.74981V13.6871H11.9045C12.1811 13.6871 12.4045 13.4637 12.4045 13.1871V8.59803H13.0826C13.3482 8.59803 13.6029 8.49335 13.7904 8.30428C14.1795 7.91366 14.1795 7.28085 13.7889 6.89022Z" />
  </svg>
);
